import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Tab, Icon, Input, Popup } from 'semantic-ui-react';
import { nunotaListAction, nunotaSavection } from '../../actions/FreteCertoActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

// Estilos
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: #f7f9fc;
  padding: 1rem;
`;

const Form = styled.form`
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const TopSections = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  flex: 1;
`;

const BottomSection = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
`;


const Title = styled.h3`
  margin-bottom: 0rem;
  color: #333;
  font-size: 1.3rem;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const HorizontalField = styled.div`
  display: flex;
//   align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
`;

const Label = styled.label`
  font-size: 0.8rem;
  color: #333;
  font-weight: 700;
  white-space: nowrap;
  width: 100px;       // <- largura fixa
  text-align: right;  // <- alinha o texto (e os :) à direita
  flex-shrink: 0;
`;

const ReadOnlyField = styled.div`
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.95rem;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  flex-wrap: nowrap;
  cursor: pointer;
`;

const SubmitButton = styled.button`
  background-color: #3f51b5;
  color: white;
  border: none;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 1rem;

  &:hover {
    background-color: #2c3e91;
  }
`;

const SmallInput = styled.input`
  width: 60px;
  padding: 0.2rem;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-align: center;
`;

const ValorItem = styled.div`
  font-size: 0.95rem;
  padding: 0.1rem;
//   margin-bottom: 0.5rem;
`;

const Total = styled.div`
  font-weight: bold;
  margin-top: 1rem;
  font-size: 1.1rem;
  border-top: 1px solid #ccc;
  padding-top: 0.5rem;
`;

const BottomBox = styled.div`
  flex: 1;
  background: #f4f4f4;
  padding: 1rem;
  border-radius: 12px;
`;

const KMLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-weight: bold;
`;

const KMValue = styled.span`
padding: 0.1rem;
  font-size: ${props => props.size === 'small' ? '0.8rem' : '1.2rem'};
  color: ${props => props.size === 'small' ? '#888' : '#000'};
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3; 
  border-top: 4px solid white; 
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;


const FormularioEntrega = (props) => {

    const { nunotaListAction, nunotalist, isNunotaLoading, eventoslist, nunotaSavection } = props; // Actions
    const { userid, isSavingLoading, menu, history, codgrupo } = props; // Reducers

    const [tiposEntrega, setTiposEntrega] = useState([]);
    const [nunota, setNunota] = useState([]);
    const [selecionados, setSelecionados] = useState([]);
    const [saveSucess, setSaveSucesss] = useState(false);


    useEffect(() => {
        // Atualiza os selecionados sempre que tiposEntrega mudar
        const selecionadosIniciais = tiposEntrega.filter((tipo, idx) => {
            return eventoslist[idx]?.nufecped && eventoslist[idx]?.nufecped !== '';
        }).map(tipo => tipo.id_regra);

        setSelecionados(selecionadosIniciais);
    }, [tiposEntrega]); // Executa toda vez que tiposEntrega mudar


    useEffect(() => {
        if (menu.filter(m => m.menuid === 35 && m.status === 1).length === 0) { history.push(`../Home`) }
    }, [menu]);

    const handleSearchNunota = () => {
        if (nunota.length >= 7) {
            const data = {
                nunota: nunota,
                codgrupo: codgrupo
            }
            nunotaListAction(data).then(dados => {
                const regras = dados.map(item => ({
                    id_regra: item.id_regra,
                    id_faixa: item.id_faixa,
                    nomeregra: item.nomeregra,
                    valor: item.valor,
                    regradetalhe: item.regradetalhe
                }));
                const selecionadosIniciais = regras.filter((tipo, idx) => {
                    // Aqui você verifica se a regra tem algum nufecped não vazio
                    return eventoslist[idx]?.nufecped && eventoslist[idx]?.nufecped !== '';
                }).map(tipo => tipo.id_regra);
                setSelecionados(selecionadosIniciais);
                setTiposEntrega(regras);
            });
        }
    };

    const handleCheckboxChange = (idRegra) => {
        if (selecionados.includes(idRegra)) {
            setSelecionados(selecionados.filter((item) => item !== idRegra));
        } else {
            setSelecionados([...selecionados, idRegra]);
        }
    };

    const totalSelecionado = selecionados.reduce((acc, id) => {
        const evento = eventoslist.find(e => e.id_regra === id);
        const valor = evento?.valor || 0;
        return acc + valor;
    }, 0);

    const handleSalvar = (event) => {
        event.preventDefault();

        if (isSavingLoading === true) {
            return
        }
        if (nunota == '') {
            return
        }

        const regrasSelecionadas = selecionados.map(id => {
            const regra = tiposEntrega.find(r => r.id_regra === id);
            return {
                id_regra: regra.id_regra,
                id_faixa: regra.id_faixa,
                valor: regra.valor
            };
        });

        const data = {
            nunota: nunota,
            userid: userid,
            eventos: regrasSelecionadas,
            codgrupo: codgrupo
        };

        nunotaSavection(data).then((dados) => {
            if (dados == 'Ok') {
                setSaveSucesss(true);
                setTimeout(() => {
                    setSaveSucesss(false);
                }, 4000);
            }

        })
    };

    return (
        <Tab.Pane>
            <Container>
                <Form onSubmit={handleSalvar}>
                    <TopSections>
                        {/* Dados */}
                        <Section>
                            <HorizontalField>
                                <Title>NuNota</Title>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <Input
                                        name="nunota"
                                        onChange={(e) => setNunota(e.target.value)}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        onBlur={handleSearchNunota}

                                        input={{
                                            style: {
                                                // padding: '0.2rem 0.5rem 0.2rem 2rem', // espaço pro ícone à esquerda
                                                border: 'none',
                                                borderBottom: '1px solid #ccc',
                                                background: 'rgba(201, 201, 201, 0.4)',
                                                borderRadius: '5px',
                                                fontSize: '0.95rem',
                                                height: '2.1rem',
                                                boxSizing: 'border-box',
                                                outline: 'none',
                                                width: '100%',
                                            }
                                        }}
                                        loading={isNunotaLoading}
                                    />
                                </div>

                                <Label>Data:</Label>
                                <p style={{ width: '100%' }}>{nunotalist?.[0]?.dtneg ? new Date(nunotalist?.[0].dtneg).toLocaleDateString('pt-BR', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                }) : ' '}</p>
                            </HorizontalField>

                            <InputGroup>

                                <HorizontalField>
                                    <Label>Parceiro:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.parceiro ? nunotalist?.[0]?.parceiro : ''}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Vendedor:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.vendedor ? nunotalist?.[0]?.vendedor : ''}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Valor Total:</Label>
                                    <ReadOnlyField>
                                        {nunotalist?.[0]?.valortotal ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(nunotalist?.[0]?.valortotal) : ''}
                                    </ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Frete Calculado:</Label>
                                    <ReadOnlyField>
                                        {nunotalist?.[0]?.fretecalculado ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(nunotalist?.[0]?.fretecalculado) : ''}
                                    </ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Frete Digitado:</Label>
                                    <ReadOnlyField>
                                        {nunotalist?.[0]?.fretedigitado ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(nunotalist?.[0]?.fretedigitado) : ''}
                                    </ReadOnlyField>
                                </HorizontalField>
                            </InputGroup>
                        </Section>

                        {/* Endereço de entrega */}
                        <Section>
                            <Title>Endereço de Entrega</Title>
                            <InputGroup>
                                <HorizontalField>
                                    <Label>Endereço:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.endereco ? nunotalist?.[0]?.endereco : ''}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Complemento:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.complemento ? nunotalist?.[0]?.complemento : ' '}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Bairro:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.bairro ? nunotalist?.[0]?.bairro : ''}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Região:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.regiao ? nunotalist?.[0]?.regiao : ''}</ReadOnlyField>
                                </HorizontalField>
                                <HorizontalField>
                                    <Label>Cidade/UF:</Label>
                                    <ReadOnlyField>{nunotalist?.[0]?.cidade_uf ? nunotalist?.[0]?.cidade_uf : ''}</ReadOnlyField>
                                </HorizontalField>
                            </InputGroup>
                        </Section>
                    </TopSections>

                    <BottomSection>
                        {/* Checkboxes */}
                        <BottomBox>
                            <Title>Entrega Certa</Title>
                            <InputGroup>
                                {tiposEntrega.map((entrega, idx) => (
                                    <CheckboxItem key={idx}>
                                        <input
                                            type="checkbox"
                                            id={`checkbox-${entrega.id_regra}`}
                                            checked={selecionados.includes(entrega.id_regra)}
                                            onChange={() => handleCheckboxChange(entrega.id_regra)} // Passando o id_regra para a função
                                        />
                                        {entrega.nomeregra}{' '}
                                        <Popup
                                            content={entrega.regradetalhe}
                                            position="top center"
                                            trigger={<Icon name="info circle" style={{ cursor: 'pointer' }} />}
                                        />
                                    </CheckboxItem>
                                ))}
                            </InputGroup>
                        </BottomBox>
                        {/* Valores */}
                        <BottomBox>
                            <Title>Valor</Title>
                            {eventoslist.map((tipo, idx) => (
                                <ValorItem key={idx}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {/* Valor original */}
                                        <div>
                                            {tipo.valor !== null
                                                ? new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL',
                                                }).format(tipo.valor)
                                                : ''}
                                        </div>

                                        {/* Verifica se o valorjasalvo é diferente de valor e exibe ao lado */}
                                        {tipo.valorjasalvo && tipo.valorjasalvo !== tipo.valor && (
                                            <div style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}>
                                                <span>Valor desatualizado: </span>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL',
                                                }).format(tipo.valorjasalvo)}
                                            </div>
                                        )}
                                    </div>
                                </ValorItem>
                            ))}
                            <Total>
                                Total:{' '}
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                }).format(totalSelecionado)}
                            </Total>
                        </BottomBox>

                        {/* Faixa KM */}
                        <BottomBox>
                            <Title>Faixa de distância KM</Title>
                            {tiposEntrega.map((_, idx) => (
                                <KMLine key={idx}>
                                    <KMValue size="small">{eventoslist?.[idx]?.faixainicial}</KMValue>
                                    <KMValue size="normal">{eventoslist?.[idx]?.distancia}</KMValue>
                                    <KMValue size="small">{eventoslist?.[idx]?.faixafinal}</KMValue>
                                </KMLine>
                            ))}
                        </BottomBox>


                    </BottomSection>
                    <SubmitButton type="submit" disabled={isSavingLoading}>
                        {isSavingLoading ? <Spinner /> : 'Salvar'}
                    </SubmitButton>
                    {saveSucess ? (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'green', fontSize: '15px' }}>
                        <p>Frete salvo com sucesso!</p>
                    </div>) : ('')}


                </Form>

            </Container>
        </Tab.Pane>
    );
};

const mapStateToProps = (state) => ({
    nunotalist: state.FreteCertoReducer.nunotalist,
    isNunotaLoading: state.FreteCertoReducer.isNunotaLoading,
    eventoslist: state.FreteCertoReducer.eventoslist,
    userid: state.LoginReducer.userid,
    codgrupo: state.LoginReducer.codgrupo,
    isSavingLoading: state.FreteCertoReducer.isSavingLoading,
    menu: state.LoginReducer.menu
});

export default withRouter(
    connect(mapStateToProps, {
        nunotaListAction,
        nunotaSavection
    })(FormularioEntrega)
);
